export default "__VITE_ASSET__9e5be670__"